(() => {
  'use strict';

  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const apply = () => {
    const path = window.location.pathname;
    if (path !== '/' && !/^\/[a-z]{2}(?:-[a-z]{2})?\/?$/i.test(path)) return;

    document.querySelectorAll('a[href]').forEach((anchor) => {
      const text = clean(anchor.textContent);
      let targetPath = '';
      try { targetPath = new URL(anchor.getAttribute('href'), window.location.origin).pathname; } catch (_) {}

      if (text.startsWith('explore more stories')) {
        anchor.setAttribute('href', '/blogs/news');
      } else if (text === 'football' && targetPath.endsWith('/collections/football')) {
        anchor.setAttribute('href', '/collections/football-boots');
      } else if (text === 'outlet' && targetPath.endsWith('/collections/outlet')) {
        anchor.setAttribute('href', '/collections/sale');
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();
})();
